import { defaultTheme } from './defaultTheme.js';
import { zIndex } from './zIndex.js';
import { lightColorTokens } from './colors/themes/light.js';
import { darkColorTokens } from './colors/themes/dark.js';

var lightTheme = Object.assign(Object.assign({}, defaultTheme), {
  colors: lightColorTokens,
  color: lightColorTokens.text,
  dropShadow: lightColorTokens.lightDropShadowTokens,
  zIndex: zIndex
});
var darkTheme = Object.assign(Object.assign({}, defaultTheme), {
  colors: darkColorTokens,
  color: darkColorTokens.text,
  dropShadow: darkColorTokens.darkDropShadowTokens,
  zIndex: zIndex
});
var getTheme = function getTheme(type) {
  return type === 'light' ? lightTheme : darkTheme;
};

export { darkTheme, getTheme, lightTheme };
